const environment = {
    isTestMode: false
};

export { environment as Environment };


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-config/environment/environment.constant.js